
/* EL VIDEO DEL HEROE, FUERA DEL CAMINO CRITICO EN CELULAR.

   «Esto se tarda una eternidad en cargar en telefono» (retro del 1-sep).
   El video pesa 2.59 MB —el archivo mas grande del sitio, y decorativo— y
   se bajaba de entrada, compitiendo con las fotos del catalogo, que es lo
   que la persona vino a ver.

   Esto tiene que correr ANTES de que el navegador vea la etiqueta: en la
   primera version iba al final del cuerpo y llegaba tarde (el video se
   pedia a los 3.6 s, el load era a los 9.0 s). El observador esta puesto
   desde la primera linea del cuerpo y desarma el video en cuanto aparece.

   En pantalla ancha no se toca nada: ahi el video es parte del diseno y la
   conexion suele aguantarlo. En pantalla estrecha se ve su primer fotograma
   —57 KB— y el video se pide despues del load, con dos segundos de respiro.
   Si nunca llega, se queda la foto y no se nota. */
(function(){
  "use strict";

  if(window.innerWidth > 760) return;
  var listo = false;
  function desarmar(v){
    if(!v || v.dataset.vDif) return;
    v.dataset.vDif = "1";
    v.removeAttribute("autoplay");
    v.preload = "none";
    try{ v.pause(); }catch(e){}
    /* Vaciar y devolver el src evita que siga la descarga ya iniciada. */
    var src = v.getAttribute("src");
    if(src){ v.removeAttribute("src"); try{ v.load(); }catch(e){} v.dataset.vSrc = src; }
    function soltar(){
      setTimeout(function(){
        if(v.dataset.vSrc){ v.setAttribute("src", v.dataset.vSrc); }
        v.preload = "auto";
        try{ v.load(); }catch(e){}
        var p = v.play(); if(p && p.catch) p.catch(function(){});
      }, 2000);
    }
    if(document.readyState === "complete") soltar();
    else window.addEventListener("load", soltar, {once:true});
  }
  function buscar(){
    var v = document.querySelector(".vh-video");
    if(v){ desarmar(v); listo = true; }
    return listo;
  }
  if(!buscar()){
    var obs = new MutationObserver(function(){ if(buscar()) obs.disconnect(); });
    obs.observe(document.documentElement, {childList:true, subtree:true});
    document.addEventListener("DOMContentLoaded", function(){ buscar(); obs.disconnect(); });
  }
})();
